@if (product$ | async; as product) {
  @if (!!(product?.description)) {
    <div class="description-box"
      >
      <p class="description-title">{{ 'eProductDetails.description.label' | cxTranslate }}</p>
      <div [innerHTML]="product.description | cxSupplementHashAnchors">
      </div>
    </div>
  }
}
